/*eslint-disable*/
import React, { useEffect, useState } from "react";
import { useParams } from "react-router";
import { Backdrop, Box, Button, Card, CircularProgress, Container, Grid, Stack, Typography } from "@mui/material";
import { RWebShare } from "react-web-share";
import PageRouteNavigator from "./pageRouteNavigator";
import axios from "axios";
import NavBar from "views/navbar";
import verifiedIcon from "../../assets/img/verified_icon.svg";

export function NftDetailsPublic() {
  const { username } = useParams();
  const [data, setData] = useState({});
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const queryParameters = new URLSearchParams(window.location.search);
  const event = queryParameters.get("event");
  const certificate = queryParameters.get("certificate");

  useEffect(async () => {
    document.body.style.background = "linear-gradient(#000, #222831, #000)";
    await fetchData();
  }, []);

  const fetchData = async () => {
    try {
      setIsLoading(true);
      const response = await axios.post("https://api.certify.social/graphql/certify-social/users", {
        query: `query ($nftId: String!) {
                list_nft_details_public(nft_id: $nftId) {
                  message
                  data {
                    _id
                    name
                    description
                    cluster
                    update_authority
                    art_url
                    royalty_percentage
                    nft_id
                    is_for_sale
                    selling_price
                    creator_id {
                      _id
                      name
                      email
                      user_name
                      wallet_id {
                        wallet_id
                      }
                    }
                    issued_at
                  }
                }
              }`,
        variables: { nftId: certificate },
      });
      const {
        list_nft_details_public: { data },
      } = response.data.data;

      setData(data);
      setIsLoading(false);
    } catch (err) {
      setIsLoading(false);
      setIsError(true);
      // window.open("https://certify.social/", "_self");
    }
  };

  return (
    <>
      <Backdrop open={isLoading} style={{ zIndex: 999 }}>
        <CircularProgress />
      </Backdrop>
      <NavBar />
      <Box sx={{ width: "100%", color: "#000" }}>
        <Container>
          <Stack sx={{ minHeight: "100vh", p: "40px 0px", pt: "100px" }}>
            <Grid container spacing={5} justifyContent="center">
              <Grid item lg={12} md={12} sm={12} xs={12}>
                <PageRouteNavigator
                  routes={[
                    { name: "organisations", path: "https://certify.social/organisations" },
                    { name: "events", path: `https://certify.social/organisation/${username}` },
                    {
                      name: "certificates",
                      path: `https://certify.social/organisation/${username}?event=${event}`,
                    },
                    { name: "details", path: "", isActive: true },
                  ]}
                />
              </Grid>
              {data ? (
                <Grid item lg={12} md={10} sm={10} xs={12}>
                  <Stack>
                    {!isError ? (
                      <Card>
                        <Stack
                          sx={{ p: { lg: 3, xs: 2 } }}
                          spacing={2}
                          // alignItems="center"
                          direction={{ lg: "row", xs: "column" }}
                        >
                          <Box width={{ lg: "50%", xs: "100%" }}>
                            <img
                              alt="Certificate image"
                              width={"100%"}
                              style={{ backgroundColor: "#fff", border: "1px solid" }}
                              src={
                                data?.art_url
                                // require("assets/img/user/profile-avatar.svg").default
                              }
                            />
                          </Box>
                          <Stack
                            spacing={1}
                            // alignItems={{ lg: "flex-start", xs: "center" }}
                            // justifyContent="center"
                            sx={{ wordBreak: "break-all" }}
                            width={{ lg: "50%", xs: "100%" }}
                          >
                            <Stack alignItems={"center"}>
                              <h2>
                                <b>{data?.name}</b>
                              </h2>
                            </Stack>
                            <Stack>
                              <Typography style={{ wordBreak: "break-word" }} variant="body1">
                                {data?.description}
                              </Typography>
                            </Stack>
                            <hr />
                            <Stack>
                              <h3>Issued Date</h3>
                            </Stack>
                            <Stack>
                              <Typography variant="body1">{data?.issued_at}</Typography>
                            </Stack>
                            <Stack>
                              <h3>Issuer</h3>
                            </Stack>
                            <Stack>
                              <Typography variant="body1" sx={{ display: "flex", alignItems: "center" }}>
                                {data?.creator_id?.name}&nbsp; <img src={verifiedIcon} width={23} />
                              </Typography>
                            </Stack>
                            <Stack>
                              <h3>Issuer's ID</h3>
                            </Stack>
                            <Stack>
                              <Typography variant="body1" sx={{ wordBreak: "break-all" }}>
                                {data?.creator_id?.wallet_id?.wallet_id}
                              </Typography>
                            </Stack>
                            <Stack>
                              <h3>Certificate ID</h3>
                            </Stack>
                            <Stack>
                              <Typography variant="body1">{certificate}</Typography>
                            </Stack>
                            {/* <Stack>
                                                            <Button
                                                                variant="contained"
                                                                fullWidth
                                                                style={{ backgroundColor: "#B5EAD7", color: "#000" }}
                                                                onClick={() =>
                                                                    window.open(
                                                                        `https://explorer.solana.com/address/${data?.nft_id}?cluster=${data?.cluster}`
                                                                    )
                                                                }
                                                            >
                                                                <b>View on blockchain</b>
                                                            </Button>
                                                        </Stack> */}
                            <Stack>
                              <RWebShare
                                data={{
                                  // text: `https://verified.certify.social/organisation/${username}?event=tiecon-kerala2022&certificate=${data?.nft_id}`,
                                  url: `https://verified.certify.social/organisation/${username}?event=${event}&certificate=${data?.nft_id}`,
                                  title: data?.name ?? "Certificate",
                                }}
                                onClick={() => console.log("shared successfully!")}
                              >
                                <Button variant="contained" fullWidth style={{ backgroundColor: "#B5EAD7", color: "#000" }}>
                                  <b>Share On Social Media</b>
                                </Button>
                              </RWebShare>
                            </Stack>
                          </Stack>
                        </Stack>
                      </Card>
                    ) : (
                      <Stack alignItems="center" justifyContent="center">
                        <h3 style={{ color: "white" }}>Certificate not available</h3>
                      </Stack>
                    )}
                  </Stack>
                </Grid>
              ) : null}
            </Grid>
          </Stack>
        </Container>
      </Box>
    </>
  );
}
